import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { ViewsBaseNav } from './ui/index.tsx';

const LazyViewsNav = lazyForPaint<typeof ViewsBaseNav>(() =>
	import(/* webpackChunkName: "async-jsm-views-nav" */ './ui').then(
		({ ViewsBaseNav }) => ViewsBaseNav,
	),
);

export const AsyncViewsNav = () => (
	<Placeholder name="horizontal-jsm-views-nav" fallback={null}>
		<LazyViewsNav />
	</Placeholder>
);
